import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import jQuery from 'jquery';
export const DateInput = (props) => {
  const styles = props.styles;
  const handleChange = props.handleChange;
  const data = props.data;
  const name = props.name;
  const max = props.max;
  const min = props.min;
  const { notRequired, className } = props;
  const submitted = props.submitted;
  const placeholder = props.placeholder;
  const [dateType, DateType] = useState('text');
  const DateTypeAction = () => (dateType == 'text' ? DateType('date') : DateType('date'));
  function preventNumberInput(e) {
    // var keyCode = e.keyCode ? e.keyCode : e.which;
    // if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 107)) {
    e.preventDefault();
    // }
  }

  $(document).ready(function() {
    $('.date').keypress(function(e) {
      preventNumberInput(e);
    });
    $('.date').keydown(function(e) {
      preventNumberInput(e);
    });
    $('.date').keyup(function(e) {
      preventNumberInput(e);
    });
  });

  return (
    <div className={styles.LoginPage__formBox}>
      <input
        type={dateType}
        className={`date ${className}`}
        placeholder={placeholder}
        name={name}
        max={max}
        min={min}
        onChange={handleChange}
        onFocus={DateTypeAction}
        onClick={DateTypeAction}
      />
      {submitted && !data && !notRequired && <div className={styles.LoginPage__error}>{placeholder} is required</div>}
    </div>
  );
};
